import { AxiosResponse } from "axios";
import axios, { APIWrapperResponse, DefaultResponse, TypedResponse } from "../general/HttpClient";

export function ListContent(allowedTypes: ImageTypes, allowedEntities: EntityTypes, skip: number, limit: number): Promise<TypedResponse<ContentViewModel[]>> {
    return axios.get(`/api/Content/ListContent`, { params: { allowedTypes, allowedEntities, skip, limit } }).then((response: AxiosResponse<APIWrapperResponse<TypedResponse<ContentViewModel[]>>>) => {
        return response.data.result;
    });
}

export function CreateContent(request: CreateContentRequest): Promise<DefaultResponse> {
    return axios.post(`/api/Content/CreateContent`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function CreateContentBulk(request: CreateContentRequest[]): Promise<DefaultResponse> {
    return axios.post(`/api/Content/CreateContentBulk`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export function DeleteContent(id: string): Promise<DefaultResponse> {
    return axios.delete(`/api/Content/DeleteContent/${id}`).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export interface ContentViewModel {
    id: string;
    name: string;
    imageURI: string;
    thumbURI: string;
    allowedTypes: ImageTypes;
    allowedEntities: EntityTypes;
}

export enum ImageTypes {
    None = 0,
    Logo = 1,
    Splash = 2,
    All = 3,
}

export enum EntityTypes {
    None = 0,
    Alias = 1,
    Team = 2,
    Match = 4,
    Tournament = 8,
    League = 16,
    Season = 32,
    Badge = 64,
    Map = 128,
    Game = 256,
    All = 511,
}

export interface CreateContentRequest {
    name: string;
    content: string;
    allowedTypes: ImageTypes;
    allowedEntities: EntityTypes;
}
